var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 62.51",
    style: {
      enableBackground: "new 0 0 120 62.51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0E5EA9;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#00AEA4;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 121,
    height: 64,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASQBJAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHzAAADFQAABAT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAEAAewMBIgACEQEDEQH/ xAB/AAACAwEBAAAAAAAAAAAAAAAABQEEBgIDAQEAAAAAAAAAAAAAAAAAAAAAEAACAgICAwEBAQEA AAAAAAABAwIEAAURFRASEyBQIRQRAAIBAwQDAQEBAAAAAAAAAAABESExAiBBEgMQUTITImESAQAA AAAAAAAAAAAAAAAAAFD/2gAMAwEAAhEDEQAAAN/zOcNJPj7BzKYbwpqGjigtNHPPQcznjQzWskIn 1QqNczoDvMtlpoPReDDNNaowuIW55o7FoZ9AHPUGXZc0jhmt0wlHYJLLIMs0pcnjpkz0kAACvk9n 4Cnye+QmHIJpcAsUa6Dm1EgAf//aAAgBAgABBQD+B//aAAgBAwABBQD+B//aAAgBAQABBQDPrDnz KUY4GQOfdXPvHgMhI+ZThHBIS8TBMbFhyLdZoarxuLpgaosSrGvf91xf/wA1a21duEhKOSPqL9xk 7NKMgrxvK/B0tj3VjpiC2E2rtZQWr1jhiCNmops65wajNg8KRr1GxajH1j42KQ1GsaUWZWlwG0tx CNaIwPcIGdwjO4RmxlC0nSWOMNtQlubPudNW9FeZx9o3VmvcgoWU3ZGbU6/2rHRZ0WdFi9d8kqJr XGIHEQbNxCwtf43dfmFO98ka9RsWogRj5P8Ao3Cfm5mw5qaWtyfzdUGofXbB1SJqVjubHPc2M7mx nc2MG5sY6crldddsm0EBSfyRyJU0SlKsqUetr51tbOtrZ1tbOtr5CoqAFNAkAAPP/9oACAECAgY/ AAP/2gAIAQMCBj8AA//aAAgBAQEGPwAia6JbglMjkiZoQnoq4JTnw0hJt8ZFl54YOo8rtk1uNZfS RwzdJE1v4bewuvre4nlePK7ErHBuq8PJkXUmOMbFhqBZqlTH34b3ObqpEvXnL3A8HSouTuPi7j7u wiS5c54VgfW3Y4zUXXi7nJqr0NexZqikxzmwunGsCxtKLly5li60Hi6Js/ediLpMWK081sZYN1Ob tIkttEC7F7FhNT9MlqyX+DxScSfpH9FizLMsyzG2v6FhDiRLfVDOTxqcWqHyj5R8o+UfKISocljU haP/2Q==",
    transform: "matrix(0.9917 0 0 -0.9766 0 62.5056)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.55,54.25h-6.51l-16.45-40.6l-14.56,40.6H9.52l17.4-48.53h0.47h6.04h0.47L53.55,54.25z M115.09,54.25h-6.39 l-16.45-40.6l-14.56,40.6h-6.51l17.4-48.53h0.47h6.04h0.36L115.09,54.25z M90,31.76h6.27l-1.89-5.21h-2.6L90,31.76z M28.46,31.76 h6.15l-1.78-5.21h-2.72L28.46,31.76z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.93,5.49H61.6h23.55l-2.25,5.8H61.6H40.17L37.93,5.49z M46.09,27.03h15.5h15.39l-1.42,5.8H61.6H47.63 L46.09,27.03z M54.61,48.57h6.98h6.86l-2.72,5.8H61.6h-4.38L54.61,48.57z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAa);
export default __webpack_public_path__ + "static/media/AA.c9b6f09ee439de5814482b7a3453090a.svg";
export { ForwardRef as ReactComponent };